export default {
  'phoneSource.systemUser': '(Systembenutzer)',
  'phoneSource.account': '(Konto)',
  'phoneSource.contact': '(Kontakt)',
  'phoneSource.lead': '(Lead)',
  'phoneType.phone': '(Telefon)',
  'phoneType.home': '(Telefon (privat))',
  'phoneType.business': '(Telefon (geschäftlich))',
  'phoneType.mobile': '(Mobiltelefon)',
  'phoneType.unknown': '(Unbekannter Telefontyp)',
  'phoneType.extension': '(Durchwahltelefon)',
};
